import React from 'react';
import { setPasswordVisibilityCookie, getCookie } from '../../utilities';

import TextInput from './TextInput';
import InputAction from 'Components/InputAction';
import ConnectedFormattedMessage from 'Containers/ConnectedFormattedMessage';

class PasswordInput extends React.Component {
  constructor(props) {
    super(props);

    const cookie = getCookie('tbsPasswordVisibility');
    const hidden = cookie && cookie === 'hidden';
    this.state = {
      passwordVisible: !hidden,
    };
    this.toggleVisibility = this.toggleVisibility.bind(this);
  }

  toggleVisibility() {
    const { passwordVisible } = this.state;
    const newValue = !passwordVisible;
    this.setState({ passwordVisible: newValue });
    setPasswordVisibilityCookie(newValue);
  }

  render() {
    const { passwordVisible } = this.state;
    const inputAction = (
      <InputAction
        clickHandler={this.toggleVisibility}
        label={
          passwordVisible ? (
            <ConnectedFormattedMessage id="form.field.password.hide" />
          ) : (
            <ConnectedFormattedMessage id="form.field.password.show" />
          )
        }
        type={passwordVisible ? 'hidePassword' : 'showPassword'}
      />
    );
    const newProps = {
      ...this.props,
      type: passwordVisible ? 'text' : 'password',
      autocapitalize: 'none',
      inputAction,
    };
    return <TextInput {...newProps} />;
  }
}

export default PasswordInput;
